module.exports = __webpack_public_path__ + "img/winas2.00261475.jpg";